module.exports = __webpack_public_path__ + "img/warn.e3e91397.svg";